import { Hide, Image, Show } from '@chakra-ui/react';
import React from 'react';
import { Link } from 'react-router-dom';
import logo from '@/assets/juicybet/images/logoJuicy.png';
import { THEME_NAME } from '@/constants/themeConfig';

export default function Index() {
  return (
    <Link to="/">
      <Show above="lg">
        <Image
          src={logo}
          alt={`${THEME_NAME.juicybet}`}
          data-testid={`${THEME_NAME.juicybet}_desktop`}
          m="auto"
          w="240px"
          h={{ base: '8', lg: 'auto' }}
        />
      </Show>
      <Hide above="lg">
        <Image
          minW="105px"
          src={logo}
          data-testid={`${THEME_NAME.juicybet}_mobile`}
          alt={`${THEME_NAME.juicybet}`}
          h="54px"
        />
      </Hide>
    </Link>
  );
}
